import React from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import { useAuth } from './state/auth'
import { AppShell } from './ui/AppShell'
import { LoginPage } from './ui/pages/LoginPage'
import { DashboardPage } from './ui/pages/DashboardPage'
import { CompaniesPage } from './ui/pages/CompaniesPage'
import { EmployeesPage } from './ui/pages/EmployeesPage'
import { CostSimulationPage } from './ui/pages/CostSimulationPage'
import { TerminationPage } from './ui/pages/TerminationPage'
import { ReportsPage } from './ui/pages/ReportsPage'
import { SettingsPage } from './ui/pages/SettingsPage'
import { PrivacyPage } from './ui/pages/PrivacyPage'
import { TermsPage } from './ui/pages/TermsPage'
import { TermsAcceptancePage } from './ui/pages/TermsAcceptancePage'

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { loading, token } = useAuth()
  if (loading) return <div className="p-6 text-slate-600">Carregando…</div>
  if (!token) return <Navigate to="/login" replace />
  return <>{children}</>
}

function RequireTerms({ children }: { children: React.ReactNode }) {
  const { me } = useAuth()
  if (me?.mustAcceptTerms) return <Navigate to="/aceite" replace />
  return <>{children}</>
}

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/privacidade', element: <PrivacyPage /> },
  { path: '/termos', element: <TermsPage /> },
  { path: '/aceite', element: <RequireAuth><TermsAcceptancePage /></RequireAuth> },
  {
    path: '/',
    element: (
      <RequireAuth>
        <RequireTerms>
          <AppShell />
        </RequireTerms>
      </RequireAuth>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'empresas', element: <CompaniesPage /> },
      { path: 'funcionarios', element: <EmployeesPage /> },
      { path: 'custo-funcionario', element: <CostSimulationPage /> },
      { path: 'rescisao', element: <TerminationPage /> },
      { path: 'relatorios', element: <ReportsPage /> },
      { path: 'configuracoes', element: <SettingsPage /> }
    ]
  }
])

